export default __webpack_public_path__ + "static/media/fc1ba46e-00d5-4277-87c5-d14b15ebd469_Top Operator Across State Mar-2022_1647799381949.54e7e151.png";